import axios from 'axios';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';

const API = `${consts.API_URL}/contaCorrenteFuncionario`;
const numero = valor => {
    if (valor === null || valor === undefined || valor === '') {
        return null;
    }

    const texto = valor.toString().trim();
    const possuiMilhar = /^-?\d{1,3}(\.\d{3})+$/.test(texto);
    const normalizado = texto.includes(',') || possuiMilhar
        ? texto.replace(/\./g, '').replace(',', '.')
        : texto;
    const resultado = Number(normalizado);

    return Number.isFinite(resultado) ? resultado : null;
};
const setAguardando = payload => ({
    type: 'CONTA_CORRENTE_AGUARDANDO', payload
});

export const getLista = filtros => async dispatch => {
    try {
        dispatch(setAguardando(true));
        const resposta = await axios.get(API, { params: filtros });
        dispatch({ type: 'CONTA_CORRENTE_LISTA', payload: resposta.data });
    } catch (ex) {
        setErroAPI(ex);
    } finally {
        dispatch(setAguardando(false));
    }
};

export const getDetalhe = filtros => async dispatch => {
    try {
        dispatch(setAguardando(true));
        const resposta = await axios.get(`${API}/detalhe`, {
            params: filtros
        });
        dispatch({ type: 'CONTA_CORRENTE_DETALHE', payload: resposta.data });
    } catch (ex) {
        setErroAPI(ex);
    } finally {
        dispatch(setAguardando(false));
    }
};

export const getTipos = () => async dispatch => {
    try {
        const resposta = await axios.get(`${API}/tipoDespesa`);
        dispatch({ type: 'CONTA_CORRENTE_TIPOS', payload: resposta.data });
    } catch (ex) {
        setErroAPI(ex);
    }
};

export const salvarTipo = registro => async dispatch => {
    try {
        if (registro.id) {
            await axios.put(`${API}/tipoDespesa`, registro);
        } else {
            await axios.post(`${API}/tipoDespesa`, registro);
        }
        setSuccess('Tipo de despesa salvo.');
        dispatch(getTipos());
    } catch (ex) {
        setErroAPI(ex);
        throw ex;
    }
};

export const excluirTipo = id => async dispatch => {
    try {
        await axios.delete(`${API}/tipoDespesa`, { params: { id } });
        setSuccess('Tipo de despesa excluído.');
        dispatch(getTipos());
    } catch (ex) {
        setErroAPI(ex);
    }
};

export const lancarCredito = (registro, filtros) => async dispatch => {
    try {
        await axios.post(`${API}/credito`, {
            ...registro,
            valor: numero(registro.valor)
        });
        setSuccess('Crédito lançado.');
        dispatch(getDetalhe(filtros));
        dispatch(getLista(filtros));
    } catch (ex) {
        setErroAPI(ex);
        throw ex;
    }
};

export const estornarCredito = (registro, filtros) => async dispatch => {
    try {
        await axios.post(`${API}/credito/estorno`, registro);
        setSuccess('Crédito estornado.');
        dispatch(getDetalhe(filtros));
        dispatch(getLista(filtros));
    } catch (ex) {
        setErroAPI(ex);
    }
};

export const decidirDespesa = (registro, filtros) => async dispatch => {
    try {
        await axios.post(`${API}/despesa/decisao`, registro);
        setSuccess(registro.status === 'APROVADA'
            ? 'Despesa aprovada.' : 'Despesa reprovada.');
        dispatch(getDetalhe(filtros));
        dispatch(getLista(filtros));
    } catch (ex) {
        setErroAPI(ex);
    }
};

export const fecharMes = (registro, filtros) => async dispatch => {
    try {
        await axios.post(`${API}/fechamento`, {
            ...registro,
            valor_acerto: numero(registro.valor_acerto) || 0
        });
        setSuccess('Acerto mensal confirmado.');
        dispatch(getDetalhe(filtros));
        dispatch(getLista(filtros));
    } catch (ex) {
        setErroAPI(ex);
        throw ex;
    }
};

export const getMinhaConta = filtros => async dispatch => {
    try {
        dispatch(setAguardando(true));
        const resposta = await axios.get(
            `${consts.API_URL}/minhaContaCorrente`,
            { params: filtros }
        );
        dispatch({ type: 'MINHA_CONTA_CORRENTE', payload: resposta.data });
    } catch (ex) {
        setErroAPI(ex);
    } finally {
        dispatch(setAguardando(false));
    }
};

export const salvarMinhaDespesa = (registro, filtros) => async dispatch => {
    try {
        const url = `${consts.API_URL}/minhaContaCorrente/despesa`;
        const dados = {
            ...registro,
            valor: numero(registro.valor)
        };
        if (registro.id) await axios.put(url, dados);
        else await axios.post(url, dados);
        setSuccess('Despesa salva e enviada para aprovação.');
        dispatch(getMinhaConta(filtros));
    } catch (ex) {
        setErroAPI(ex);
        throw ex;
    }
};

export const cancelarMinhaDespesa = (id, filtros) => async dispatch => {
    try {
        await axios.delete(
            `${consts.API_URL}/minhaContaCorrente/despesa`,
            { params: { id } }
        );
        setSuccess('Despesa cancelada.');
        dispatch(getMinhaConta(filtros));
    } catch (ex) {
        setErroAPI(ex);
    }
};
